import { Actioner } from "@services/actioner";
import { Campaign, type CampaignResult, Result } from "@services/sdk/models";
import ErrorResponseFactory from "@services/sdk/models/error-response-factory";
import type { AxiosInstance } from "axios";

export const createMRTMCampaignsAdapter = (httpClient: AxiosInstance) => ({
	async verifyPromoCode(props: {
		code: string;
		event?: string;
		simChannel?: string;
		msisdn?: string;
		type?: "PHYSICAL" | "ESIM";
		productId?: number;
	}): Promise<CampaignResult> {
		const {
			code,
			event = "BUY",
			simChannel = "NON_RETAIL",
			msisdn,
			type,
			productId,
		} = props;
		try {
			const response = await httpClient.get("/campaigns", {
				params: {
					code: code.toUpperCase(),
					event,
					simChannel,
					productId,
					msisdn,
					type,
				},
			});
			return Result.Success(Campaign.Construct(response.data.data));
		} catch (err: any) {
			Actioner.trigger(Actioner.keyDefs.ERROR, err);
			return Result.Failure(ErrorResponseFactory.ErrorVerifyPromoCode(err));
		}
	},
});
